<template>
  <div class="admin-page page-body">
    <div class="admin-page__inner">
      <header class="admin-head">
        <button type="button" class="admin-head__back" @click="goBack">‹ 返回产品中心</button>
        <div>
          <span class="section-eyebrow">Product Shelf</span>
          <h1 class="admin-head__title">上架新产品</h1>
          <p class="admin-head__sub">
            与手机 App 相同：填写信息后保存，产品将出现在对应分类的产品列表，并支持进入详情页预览与编辑。
          </p>
        </div>
      </header>

      <section v-if="customList.length" class="admin-panel admin-panel--list">
        <div class="admin-panel__head">
          <h2 class="admin-panel__title">已上架产品</h2>
          <span class="admin-panel__badge">{{ customList.length }} 款</span>
        </div>
        <ul class="saved-list">
          <li v-for="item in customList" :key="item.id" class="saved-card">
            <img v-if="item.image" :src="item.image" :alt="item.name" class="saved-card__img" />
            <div v-else class="saved-card__img saved-card__img--empty">暂无图</div>
            <div class="saved-card__body">
              <strong class="saved-card__name">{{ item.name }}</strong>
              <p class="saved-card__meta">
                {{ getShelfCategoryLabel(item.categoryId) }} · {{ item.summary }}
              </p>
            </div>
            <div class="saved-card__actions">
              <button type="button" class="saved-card__link" @click="editProduct(item)">编辑</button>
              <button type="button" class="saved-card__link" @click="previewProduct(item)">预览</button>
              <button type="button" class="saved-card__link saved-card__link--danger" @click="removeProduct(item.id)">
                删除
              </button>
            </div>
          </li>
        </ul>
      </section>

      <form class="admin-panel form-card" @submit.prevent="submit">
        <div class="admin-panel__head admin-panel__head--form">
          <div>
            <h2 class="admin-panel__title">{{ editingId ? '编辑产品' : '新增产品' }}</h2>
            <p class="admin-panel__desc">带 <span class="req">*</span> 为必填项</p>
          </div>
          <span v-if="editingId" class="admin-panel__status">编辑中</span>
        </div>

        <fieldset class="form-section">
          <legend class="form-section__title">基本信息</legend>
          <div class="form-grid">
            <label class="form-group form-group--span-2">
              <span class="form-label">产品名称 <span class="req">*</span></span>
              <input v-model="form.name" class="form-input" placeholder="例如：六轴工业机器人实训平台" />
            </label>

            <label class="form-group">
              <span class="form-label">产品分类 <span class="req">*</span></span>
              <select v-model="form.categoryId" class="form-input">
                <option v-for="cat in SHELF_CATEGORIES" :key="cat.id" :value="cat.id">{{ cat.label }}</option>
              </select>
            </label>

            <label class="form-group form-group--span-2">
              <span class="form-label">一句话简介 <span class="req">*</span></span>
              <input v-model="form.summary" class="form-input" maxlength="60" placeholder="卡片上显示的简短说明" />
              <span class="form-hint">{{ form.summary.length }}/60</span>
            </label>
          </div>
        </fieldset>

        <fieldset class="form-section">
          <legend class="form-section__title">展示素材</legend>

          <div class="form-group">
            <span class="form-label">产品图片</span>
            <div class="image-upload">
              <label class="image-upload__picker">
                <input type="file" accept="image/*" hidden @change="onImageFile" />
                <img v-if="form.image" :src="form.image" alt="预览" class="image-upload__preview" />
                <span v-else class="image-upload__placeholder">
                  <span class="image-upload__icon">+</span>
                  <span>点击上传图片</span>
                </span>
              </label>
            </div>
            <div class="image-path-row">
              <input
                v-model="form.image"
                class="form-input form-input--compact"
                placeholder="或填写图片路径，如 /images/brochure/img-p9-5.jpeg"
              />
              <button v-if="form.image" type="button" class="image-path-clear" @click="form.image = ''">清除</button>
            </div>
          </div>

          <div class="form-grid">
            <label class="form-group">
              <span class="form-label">产品亮点</span>
              <input v-model="form.highlightsText" class="form-input" placeholder="多个用逗号分隔" />
              <ul v-if="highlightTags.length" class="tag-preview">
                <li v-for="tag in highlightTags" :key="tag">{{ tag }}</li>
              </ul>
            </label>

            <label class="form-group">
              <span class="form-label">规格标签</span>
              <input v-model="form.specsText" class="form-input" placeholder="多个用逗号分隔" />
              <ul v-if="specTags.length" class="tag-preview tag-preview--muted">
                <li v-for="tag in specTags" :key="tag">{{ tag }}</li>
              </ul>
            </label>
          </div>
        </fieldset>

        <fieldset class="form-section">
          <legend class="form-section__title">详情文案</legend>

          <label class="form-group">
            <span class="form-label">产品介绍</span>
            <textarea v-model="form.description" class="form-textarea" rows="4" placeholder="详情页「产品介绍」正文" />
          </label>

          <label class="form-group">
            <span class="form-label">详情补充（选填）</span>
            <textarea
              v-model="form.detailContent"
              class="form-textarea form-textarea--tall"
              rows="6"
              placeholder="可写多段详情，段落之间空一行"
            />
            <span class="form-hint">段落之间空一行，详情页将自动分段展示</span>
          </label>
        </fieldset>

        <div class="form-actions">
          <button v-if="editingId" type="button" class="btn btn--ghost" @click="resetForm">取消编辑</button>
          <button type="submit" class="btn btn--primary" :disabled="saving">
            {{ saving ? '保存中...' : editingId ? '保存修改' : '上架产品' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import {
  SHELF_CATEGORIES,
  loadCustomProductsRaw,
  addCustomProduct,
  updateCustomProduct,
  removeCustomProduct,
  findCustomProductBySlug,
  getShelfCategoryLabel,
  readImageFile,
} from '../utils/customProductCatalog'

const router = useRouter()
const route = useRoute()

const customList = ref([])
const saving = ref(false)
const editingId = ref('')

const form = reactive({
  name: '',
  categoryId: SHELF_CATEGORIES[0].id,
  summary: '',
  description: '',
  image: '',
  highlightsText: '',
  specsText: '',
  detailContent: '',
})

const highlightTags = computed(() =>
  form.highlightsText
    .split(/[,，]/)
    .map((s) => s.trim())
    .filter(Boolean)
    .slice(0, 8)
)

const specTags = computed(() =>
  form.specsText
    .split(/[,，]/)
    .map((s) => s.trim())
    .filter(Boolean)
    .slice(0, 8)
)

function refreshList() {
  customList.value = loadCustomProductsRaw()
}

function resetForm() {
  editingId.value = ''
  form.name = ''
  form.categoryId = SHELF_CATEGORIES[0].id
  form.summary = ''
  form.description = ''
  form.image = ''
  form.highlightsText = ''
  form.specsText = ''
  form.detailContent = ''
}

async function onImageFile(e) {
  const file = e.target.files?.[0]
  if (!file) return
  try {
    form.image = await readImageFile(file)
  } catch {
    ElMessage.error('图片读取失败，请重试或填写图片路径。')
  }
  e.target.value = ''
}

function submit() {
  if (!form.name.trim() || !form.summary.trim()) {
    ElMessage.warning('请填写产品名称和一句话简介。')
    return
  }

  saving.value = true
  const payload = { ...form }

  setTimeout(() => {
    if (editingId.value) {
      updateCustomProduct(editingId.value, payload)
      ElMessage.success('产品已更新')
    } else {
      addCustomProduct(payload)
      ElMessage.success('上架成功')
    }
    saving.value = false
    resetForm()
    refreshList()
  }, 300)
}

function editProduct(item) {
  editingId.value = item.id
  form.name = item.name
  form.categoryId = item.categoryId
  form.summary = item.summary
  form.description = item.description || ''
  form.image = item.image || ''
  form.highlightsText = (item.highlights || []).join('，')
  form.specsText = (item.specs || []).join('，')
  form.detailContent = item.detailContent || (item.introParagraphs || []).join('\n\n')
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

function previewProduct(item) {
  router.push({
    name: 'product-detail',
    params: { categoryId: item.categoryId, productSlug: item.slug },
  })
}

function removeProduct(id) {
  ElMessageBox.confirm('确定从货架移除该自定义产品吗？', '删除产品', {
    confirmButtonText: '删除',
    cancelButtonText: '取消',
    type: 'warning',
  })
    .then(() => {
      removeCustomProduct(id)
      refreshList()
      if (editingId.value === id) resetForm()
      ElMessage.success('已删除')
    })
    .catch(() => {})
}

function goBack() {
  router.push({ name: 'products' })
}

function loadEditFromQuery() {
  const edit = route.query.edit
  if (typeof edit !== 'string' || !edit) return
  const found = findCustomProductBySlug(edit)
  if (found?.raw) editProduct(found.raw)
}

onMounted(() => {
  refreshList()
  loadEditFromQuery()
})

watch(
  () => route.query.edit,
  () => loadEditFromQuery()
)
</script>

<style scoped>
.admin-page {
  padding: 32px 0 64px;
}

.admin-page__inner {
  max-width: 920px;
  margin: 0 auto;
  padding: 0 var(--page-padding-x);
}

.admin-head {
  margin-bottom: 28px;
}

.admin-head__back {
  border: none;
  background: transparent;
  padding: 0;
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 600;
  color: var(--brand-primary);
  cursor: pointer;
}

.admin-head__title {
  margin: 8px 0 0;
  font-size: 32px;
  font-weight: 800;
}

.admin-head__sub {
  margin: 12px 0 0;
  max-width: 640px;
  font-size: 14px;
  line-height: 1.75;
  color: var(--text-secondary);
}

.admin-panel {
  margin-bottom: 24px;
  padding: 24px 28px;
  border-radius: var(--radius-lg);
  background: var(--surface-card);
  border: 1px solid var(--border-soft);
  box-shadow: var(--shadow-card);
}

.admin-panel__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
}

.admin-panel__head--form {
  align-items: flex-start;
  padding-bottom: 18px;
  margin-bottom: 22px;
  border-bottom: 1px solid var(--border-soft);
}

.admin-panel__title {
  margin: 0;
  font-size: 20px;
  font-weight: 800;
}

.admin-panel__desc {
  margin: 6px 0 0;
  font-size: 13px;
  color: var(--text-muted);
}

.admin-panel__badge,
.admin-panel__status {
  padding: 6px 14px;
  border-radius: var(--radius-pill);
  font-size: 12px;
  font-weight: 700;
}

.admin-panel__badge {
  color: var(--brand-primary);
  background: rgba(13, 79, 110, 0.08);
}

.admin-panel__status {
  color: var(--brand-secondary);
  background: rgba(31, 168, 98, 0.1);
}

.form-section {
  border: none;
  margin: 0;
  padding: 0;
}

.form-section + .form-section {
  margin-top: 28px;
  padding-top: 24px;
  border-top: 1px solid var(--border-soft);
}

.form-section__title {
  display: block;
  margin-bottom: 16px;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--text-secondary);
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group--span-2 {
  grid-column: 1 / -1;
}

.form-label {
  font-size: 13px;
  font-weight: 700;
  color: var(--text-primary);
}

.req {
  color: #d64545;
}

.form-input,
.form-textarea {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid var(--border-soft);
  border-radius: var(--radius-md);
  background: #f9fbfe;
  font: inherit;
  color: var(--text-primary);
  box-sizing: border-box;
}

.form-input:focus,
.form-textarea:focus {
  outline: none;
  border-color: var(--brand-primary);
  box-shadow: 0 0 0 4px rgba(13, 79, 110, 0.1);
}

.form-textarea {
  resize: vertical;
  min-height: 100px;
}

.form-textarea--tall {
  min-height: 160px;
}

.form-hint {
  font-size: 12px;
  color: var(--text-muted);
}

.image-upload__picker {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 220px;
  border: 2px dashed rgba(13, 79, 110, 0.24);
  border-radius: var(--radius-lg);
  background: #f4f9fc;
  cursor: pointer;
  overflow: hidden;
}

.image-upload__preview {
  width: 100%;
  max-height: 280px;
  object-fit: contain;
}

.image-upload__placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: var(--text-secondary);
  font-size: 14px;
}

.image-upload__icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(13, 79, 110, 0.1);
  color: var(--brand-primary);
  font-size: 32px;
  line-height: 56px;
  text-align: center;
}

.image-path-row {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.form-input--compact {
  flex: 1;
}

.image-path-clear {
  flex-shrink: 0;
  padding: 0 16px;
  border: none;
  border-radius: var(--radius-md);
  background: rgba(214, 69, 69, 0.08);
  color: #d64545;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.tag-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  list-style: none;
  margin: 4px 0 0;
  padding: 0;
}

.tag-preview li {
  padding: 5px 12px;
  border-radius: var(--radius-pill);
  font-size: 12px;
  font-weight: 600;
  color: var(--brand-primary);
  background: rgba(13, 79, 110, 0.08);
}

.tag-preview--muted li {
  color: var(--text-secondary);
  background: var(--surface-muted);
}

.saved-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.saved-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px;
  border-radius: var(--radius-md);
  background: #f8fbff;
  border: 1px solid var(--border-soft);
}

.saved-card__img {
  width: 72px;
  height: 72px;
  border-radius: var(--radius-sm);
  object-fit: cover;
  flex-shrink: 0;
  background: #eaf2fb;
}

.saved-card__img--empty {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: var(--text-muted);
}

.saved-card__body {
  flex: 1;
  min-width: 0;
}

.saved-card__name {
  display: block;
  font-size: 15px;
}

.saved-card__meta {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.saved-card__actions {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex-shrink: 0;
}

.saved-card__link {
  border: none;
  background: transparent;
  padding: 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--brand-primary);
  cursor: pointer;
}

.saved-card__link--danger {
  color: #d64545;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 28px;
  padding-top: 20px;
  border-top: 1px solid var(--border-soft);
}

@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }

  .form-group--span-2 {
    grid-column: auto;
  }

  .saved-card {
    flex-wrap: wrap;
  }

  .saved-card__actions {
    flex-direction: row;
    width: 100%;
    justify-content: flex-end;
  }

  .form-actions {
    flex-direction: column;
  }
}
</style>
